import { IShipmentStates } from 'types/graphqlTypes'
import { SHIPMENT_STATE_LABELS } from 'apps/marketplace/pages/shipment-details/components/Header/ShipmentInfo/types'
import { ITrailerStatusOption, ILoadTypeOption } from './types'

export const TRAILER_STATUS_SELECT_OPTIONS: ITrailerStatusOption[] = [
  {
    label: 'Assigned to Facility',
    value: 'assigned_to_facility',
  },
  {
    label: 'Assigned to Shipment',
    value: 'assigned_to_shipment',
  },
  {
    label: 'Empty at Delivery',
    value: 'empty_at_delivery',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
  {
    label: 'Unassigned',
    value: 'unassigned',
  },
]

export const TRAILER_STATUS_CHECKBOX_OPTIONS = TRAILER_STATUS_SELECT_OPTIONS.map(status => ({
  ...status,
  id: status.value,
}))

export const ON_HOLD_TO_DELIVERED_STATES = [
  IShipmentStates.on_hold,
  IShipmentStates.alerted,
  IShipmentStates.tendered,
  IShipmentStates.covered,
  IShipmentStates.offered,
  IShipmentStates.waterfall_offered,
  IShipmentStates.assigned,
  IShipmentStates.dispatched,
  IShipmentStates.arrived_for_pickup,
  IShipmentStates.truck_ordered_not_used,
  IShipmentStates.in_transit,
  IShipmentStates.arrived_for_delivery,
  IShipmentStates.delivered,
]

export const ON_HOLD_TO_DELIVERED_CHECKBOX_OPTIONS = ON_HOLD_TO_DELIVERED_STATES.map(state => {
  return {
    id: state,
    label: SHIPMENT_STATE_LABELS[state],
  }
})

export const SHIPMENT_STATE_CHECKBOX_OPTIONS = Object.entries(SHIPMENT_STATE_LABELS).map(
  ([id, label]) => ({
    id,
    label,
  })
)

export const LOAD_TYPE_SELECT_OPTIONS: ILoadTypeOption[] = [
  {
    label: 'Drop',
    value: 'drop',
  },
  {
    label: 'Live',
    value: 'live',
  },
]

export const SORT_VALUES_MISSING_TRAILERS: { [key: string]: string } = {
  shipper_id: 'shipper_application_id',
  state: 'updated_at',
  pickup_date: 'updated_at',
}

export const SORT_VALUES_KNOWN_TRAILERS: { [key: string]: string } = {
  shipper_application_id: 'shipper_id',
}
